module.exports = "/_next/static/images/contact@3x-aba9f91324f0c8b0154fee593b351788.png";